export const orderNameBodyTemplateShort = (product: any) => {
    return orderNameBodyTemplate(product, 40);
};
export const ordersNameBodyTemplateLong = (product: any) => {
    return orderNameBodyTemplate(product, Number.MAX_SAFE_INTEGER);
};

export const orderNameBodyTemplate = (product: any, maxLength: number) => {
    const shortenedDescription =
        (product.description || '').length > maxLength
            ? product.description.substring(0, maxLength) + '...'
            : product.description || '-';

    return (
        <>
            <span
                className="block text-xs font-bold white-space-normal w-full max-w-12rem sm:max-w-16rem md:max-w-none overflow-hidden"
                style={{
                    minWidth: '2rem', // echte Mindestbreite
                    overflowWrap: 'anywhere', // bricht auch mitten im Wort
                    wordBreak: 'break-all', // Fallback/extra aggressiv
                    hyphens: 'auto', // Silbentrennung, wenn möglich (lang="de")
                }}
            >
                {product.name}
            </span>

            <span
                className="block text-xs white-space-normal w-full max-w-12rem sm:max-w-16rem md:max-w-none overflow-hidden"
                style={{
                    minWidth: '2rem',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-all',
                    hyphens: 'auto',
                }}
            >
                {shortenedDescription}
            </span>
        </>
    );
};

export const ordersImageBodyTemplate = (product: any) => {
    return (
        <div
            className="
        inline-flex align-items-center justify-content-center
        w-3rem h-3rem sm:w-4rem sm:h-4rem
        border-round-md overflow-hidden m-0_5 flex-shrink-0
      "
        >
            {product.image ? (
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full block"
                    style={{ objectFit: 'cover' }}
                />
            ) : (
                <i
                    className="pi pi-image text-500 text-3xl sm:text-4xl"
                    style={{ lineHeight: 1 }}
                />
            )}
        </div>
    );
};
